import { Link } from 'react-router';
import Functions from '../../../functions';
import iconFile from '../../assets/images/icon_data.gif';
import type { ItemData } from '../../lib/ItemUtil';
import ListBase, { type ListBaseProps } from '../lib/ListBase';

class DataList extends ListBase {
    constructor(props: ListBaseProps) {
        super(props);
        this.label = 'Data';
        this.icon = iconFile;
    }

    renderBody() {
        const { lang } = this.props;
        const item = this.props.item as ItemData;
        const authors = item.experimenter.map((author) => Functions.mlang(author, lang)).join(', ');
        return (
            <>
                <Link to={this.url}>{Functions.mlang(item.title, lang)}</Link>
                <br />
                {authors}
            </>
        );
    }
}

export default DataList;
